import { render } from "./S348161.vue?vue&type=template&id=62a17aac"
const script = {}
script.render = render

export default script